var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgThumbsDown = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M12.563 8.813h3.374v-6.75h-3.374zm0-.001-2.25 3.897v2.854a.376.376 0 0 1-.375.374H8.813a1.5 1.5 0 0 1-1.5-1.5v-3H3.638a1.502 1.502 0 0 1-1.452-1.886l1.4-5.261a3 3 0 0 1 2.898-2.231h6.075" }) }))); };
export default SvgThumbsDown;
